<template>
  <div>
    <p class="assign-teams__dialog-form-msg">
      Move user <b>{{ userEmail }}</b> from <b>{{ currentVendor.name }}</b> to:
    </p>
    <ElementForm
      ref="updateVendorForm"
      label-position="top"
      class="assign-teams__dialog-form"
      :model="updateVendorForm"
      hide-required-asterisk
    >
      <ElementFormItem
        prop="vendor"
        class="assign-teams__dialog-form-item"
      >
        <ElementSelect
          v-model="updateVendorForm.id"
          placeholder="Select a vendor company"
          filterable
        >
          <ElementOption
            v-for="vendor in vendors"
            :key="vendor.id"
            :label="vendor.name"
            :value="vendor.id"
            :disabled="vendor.id === currentVendor.id"
          />
        </ElementSelect>
        <p class="assign-teams__dialog-form-msg">
          This vendor user will be moved to the new vendor company.
        </p>
      </ElementFormItem>
    </ElementForm>
    <div
      slot="footer"
      class="assign-teams__dialog-buttons"
    >
      <ElementButton
        plain
        class="assign-teams__dialog-form__cancel"
        @click="closeUpdateUserVendorForm"
      >
        Cancel
      </ElementButton>
      <ElementButton
        type="primary"
        plain
        class="assign-teams__dialog-form__submit"
        :loading="isLoading"
        :disabled="!updateVendorForm.id"
        @click="submitForm"
      >
        Move
      </ElementButton>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UpdateUserVendorForm',

  props: {
    userId: {
      type: Number,
      required: true
    },
    userEmail: {
      type: String,
      required: true
    },
    vendorId: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      isLoading: false,
      updateVendorForm: {
        id: null,
        name: null
      }
    }
  },

  computed: {
    ...mapGetters({
      vendors: 'getVendors'
    }),

    /**
     * @returns {object}
     */
    currentVendor () {
      return this.vendors.find(vendor => vendor.id === this.vendorId)
    }
  },

  async created () {
    try {
      await this.fetchVendors()
    } catch (error) {
      if (error.response) {
        console.error('Something went wrong while fetching vendors')
      } else {
        throw error
      }
    }
  },

  methods: {
    ...mapActions([
      'changeUserTeams',
      'updateVendorTeams',
      'fetchVendors',
      'updateUserVendor'
    ]),

    /**
     */
    closeUpdateUserVendorForm () {
      this.$emit('close-update-user-vendor-form')
      this.updateVendorForm = {
        id: null,
        name: null
      }
    },

    /**
     */
    async submitForm () {
      this.isLoading = true

      await this.updateUserVendor({
        vendorId: this.updateVendorForm.id,
        userId: this.userId
      })

      this.isLoading = false
      this.closeUpdateUserVendorForm()
    }
  }
}
</script>

<style lang="scss" scoped>
.assign-teams__dialog-buttons {
  text-align: center;
}

.assign-teams__dialog-form {
  width: spacing(50);
}

.assign-teams__dialog-form-msg {
  padding: spacing(1.5) 0;
}

.assign-teams__dialog-form-item {
  /deep/ .el-form-item__label {
    padding: 0;
  }

  /deep/ .el-select {
    width: 100%;
  }
}
</style>
